import { FormFieldBase } from './form-field-base.model';

export class FormFieldNumberChips extends FormFieldBase<any> {
  override controlType = 'number-chips';
}
